import axios from 'axios';

// Base da API:
// - Se REACT_APP_API_BASE estiver definida, normaliza e, se for apenas a ORIGEM (sem path), acrescenta '/api'.
// - Caso contrário, se não for localhost (produção), usa same-origin em '/api' para evitar CORS.
// - Em desenvolvimento local, usa http://localhost:3001
const inferBase = () => {
  const envBase = process.env.REACT_APP_API_BASE;
  if (envBase && envBase.trim()) {
    const raw = envBase.trim().replace(/\/$/, '');
    try {
      const u = new URL(raw);
      // Se a URL não possui caminho além de '/', presume origem do backend e adiciona '/api'
      if (!u.pathname || u.pathname === '/') {
        return `${raw}/api`;
      }
      return raw;
    } catch (_) {
      // Se não for uma URL absoluta, retorna como está (pode ser '/api' explícito)
      return raw;
    }
  }

  const isBrowser = typeof window !== 'undefined' && typeof window.location !== 'undefined';
  const host = isBrowser ? window.location.hostname : '';
  const isLocalhost = /^(localhost|127\.0\.0\.1|\[::1\])$/.test(host);
  if (!isLocalhost && isBrowser) {
    // Produção com mesmo domínio do site
    return '/api';
  }
  return 'http://localhost:3001';
};

const baseURL = inferBase();

const api = axios.create({
  baseURL,
  withCredentials: false,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor para incluir token, se existir
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {
    // ignore
  }
  return config;
});

// Interceptor de resposta: retorna diretamente o corpo (data)
api.interceptors.response.use(
  (response) => response.data,
  (error) => Promise.reject(error)
);

export default api;
